import { context } from '@wikia/ad-engine';

export function getMedianetContext(): object {
	const midBoxAdConfigs = context.get('options.replaceOpenWebWithMidBoxAd')
		? {
				mid_boxad: {
					sizes: [[300, 250]],
					cid: '8CU5JOKX4',
					crid: '385056381',
				},
			}
		: {};

	return {
		enabled: false,
		slots: {
			top_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.top_leaderboard ?? [
					[728, 90],
					[970, 90],
					[970, 250],
				],
				cid: '8CU5JOKX4',
				crid: '648224147',
			},
			top_boxad: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.top_boxad ?? [
					[300, 250],
					[300, 600],
				],
				cid: '8CU5JOKX4',
				crid: '307922149',
			},
			...midBoxAdConfigs,
			incontent_boxad: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.incontent_boxad ?? [
					[300, 250],
					[300, 600],
					[300, 1050],
				],
				cid: '8CU5JOKX4',
				crid: '210414245',
			},
			bottom_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.desktop?.bottom_leaderboard ?? [
					[728, 90],
					[970, 90],
					[970, 250],
				],
				cid: '8CU5JOKX4',
				crid: '550202278',
			},
		},
	};
}
